import { render, staticRenderFns } from "./invoiceOrderDtl.vue?vue&type=template&id=34480877&scoped=true&"
import script from "./invoiceOrderDtl.vue?vue&type=script&lang=js&"
export * from "./invoiceOrderDtl.vue?vue&type=script&lang=js&"
import style0 from "./invoiceOrderDtl.vue?vue&type=style&index=0&id=34480877&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34480877",
  null
  
)

export default component.exports